export default "__VITE_ASSET__Den$jEY___"